// extracted by mini-css-extract-plugin
export default {"inSameLine":"BusinessCashbackSplitage_inSameLine__5qkB9"};